import { FlexCenterCol } from ".";
import { ISelectableBox } from "@/interfaces";
import { cn } from "@/lib";

const SelectableBox = ({
  icon,
  label,
  isSelected,
  onClick,
  id,
}: ISelectableBox & { onClick: (id: string) => void }) => {
  return (
    <FlexCenterCol gap={3} className="lg:gap-8">
      <FlexCenterCol
        gap={2}
        onClick={() => onClick(id)}
        className={cn(
          "] shadow-main size-16 cursor-pointer overflow-hidden rounded-xl border-[1.5px] border-transparent bg-white p-1 transition sm:p-2 lg:size-36",
          isSelected && "border-primary-main shadow-main-primary",
        )}
      >
        <div
          className={cn(
            "size-10 transition sm:size-10 lg:size-16",
            isSelected && "text-primary-main",
          )}
        >
          {icon}
        </div>
        <p
          className={cn(
            "hidden text-lg font-bold transition-colors lg:block",
            isSelected && "text-primary-main",
          )}
        >
          {label}
        </p>
      </FlexCenterCol>
      {isSelected && (
        <span className="bg-primary-main shadow-main-primary size-3 rounded-full lg:size-5"></span>
      )}
    </FlexCenterCol>
  );
};

export default SelectableBox;
